export default (parent = {}) => {
    const { model } = parent;

    const tourProduct = model.get('cheapestTourProduct');
    const hotelOfferProduct = model.get('cheapestHotelOfferProduct');
    const railwayTourProduct = model.get('cheapestRailwayProduct');

    const tour = tourProduct?.get('tour');
    const hotelOffer = hotelOfferProduct?.get('hotelOffer');
    const railwayTour = railwayTourProduct?.get('railwayTour');

    const product = tour || hotelOffer || railwayTour;

    const productData = tourProduct || hotelOfferProduct || railwayTourProduct;

    const nights = product.get('nights');
    const nightsInHotel = product.get('nightsInHotel');

    return {
        tour,
        hotelOffer,
        railwayTour,
        product,
        nights,
        nightsInHotel,
        differentNightsInHotel: nights !== nightsInHotel,
        productType: productData.get('type'),
    };
};
